import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LngDetector from "i18next-browser-languagedetector";
import XHR from "i18next-http-backend";
import translationEN from "@public/locales/en/translations.json";
import translationNL from "@public/locales/nl/translations.json";
const resources = {
    en: {
        translation: translationEN,
    },
    nl: {
        translation: translationNL,
    },
};
i18n
    .use(XHR) // Enables loading translation files dynamically if needed
    .use(LngDetector) // Detects user's language
    .use(initReactI18next) // Initializes react-i18next
    .init({
    resources, // Static resources for translations
    fallbackLng: "en", // Default language
    keySeparator: ".", // Use dot notation for nested keys
    interpolation: {
        escapeValue: false, // React already escapes strings by default
        format: (value, format, lng) => {
            if (format === "currency") {
                return new Intl.NumberFormat(lng, {
                    style: "decimal",
                    minimumFractionDigits: lng === "nl" ? 3 : 2,
                    maximumFractionDigits: lng === "nl" ? 3 : 2,
                }).format(value);
            }
            if (format === "number") {
                return new Intl.NumberFormat(lng, {
                    style: "decimal",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                }).format(value);
            }
            return value;
        },
    },
});
export default i18n;
